import React, { useCallback, memo } from 'react';
import { Button, Grid } from '@material-ui/core';
import classNames from 'classnames';
import CropFreeIcon from '@material-ui/icons/CropFree';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import SettingsIcon from '@material-ui/icons/Settings';
import { useStyles } from './cardapio-meu-menu-style';
import { useHistory, useParams } from 'react-router-dom';
import { VoltarIcon } from 'utils';
import { useThemeQueries } from 'components/dialogs/dialog-adicionar-produto-com-subitem/util-styles';
import { TokenGestaoEmpresaTipoEnum } from 'api/master/models/token/token-gestao-empresa-model';
import { useObterToken } from 'services/store/obter-token';

export interface CardapioMeuMenuProps {
  setCarregando: (carregando: boolean) => any;
  onVisualizarClick: () => any;
  visualizacao: 'configuracao' | 'gerarQrCode' | 'cardapio' | 'acompanharPedido'
  adminLogado: boolean
}

export const CardapioMeuMenu = ({
  setCarregando,
  onVisualizarClick,
  visualizacao,
  adminLogado
}: CardapioMeuMenuProps) => {
  const classes = useStyles();
  const history = useHistory()
  const { empresaId } = useParams<{ empresaId: string }>()
  const { isMobile } = useThemeQueries()
  const getTokenTipo = useObterToken(state => state.getTokenTipo)

  const handleCloseWrapper = useCallback((funcao, carregando: boolean) => {
    setCarregando(carregando || false);
    carregando ? setTimeout(() => funcao(), 1) : funcao();
  }, [setCarregando]);

  const navegarConfiguracao = useCallback(() => {
    history.push(`/${empresaId}/configuracoes`);
  }, [empresaId, history]);

  const navegarQrCode = useCallback(() => {
    history.push(`/${empresaId}/gerar-qrcode`);
  }, [empresaId, history]);
  if (!adminLogado && visualizacao !== 'acompanharPedido') return null
  if (getTokenTipo() === TokenGestaoEmpresaTipoEnum.Cliente && visualizacao !== 'acompanharPedido') return null

  if (isMobile && visualizacao !== 'acompanharPedido') return null

  return (
    <Grid item xs={visualizacao === 'acompanharPedido' ? true : 12}>
      <div className={classes.meuMenu}>
        {visualizacao === 'acompanharPedido' && (
          <Button
            variant={'outlined'}
            color="default"
            className={classNames(visualizacao !== 'acompanharPedido' && classes.notActive)}
            onClick={() => handleCloseWrapper(onVisualizarClick, false)}
          >
            <VoltarIcon tipo="BUTTON" class={classes.icon} />
            Voltar ao Catálogo
          </Button>
        )}
        {adminLogado && visualizacao !== 'acompanharPedido' && (
          <>
            <Button
              variant={'outlined'}
              color="default"
              className={classNames(visualizacao !== 'cardapio' && classes.notActive)}
              onClick={() => handleCloseWrapper(onVisualizarClick, false)}
            >
              <OpenInBrowserIcon color="inherit" style={{ marginRight: 10 }} />
              Modo Visualização
            </Button>
            <Button
              variant={'outlined'}
              color="default"
              className={classNames(visualizacao !== 'gerarQrCode' && classes.notActive)}
              onClick={() => handleCloseWrapper(navegarQrCode, false)}
            >
              <CropFreeIcon color="inherit" style={{ marginRight: 10 }} />
              Gerar Código QR
            </Button>
            <Button
              variant={'outlined'}
              color="default"
              className={classNames(visualizacao !== 'configuracao' && classes.notActive)}
              onClick={() => handleCloseWrapper(navegarConfiguracao, false)}
            >
              <SettingsIcon color="inherit" style={{ marginRight: 10 }} />
              Configurações
            </Button>
          </>
        )}
      </div>
    </Grid>
  );
};
export const MeuMenu = memo(CardapioMeuMenu);
